import React, { Component } from 'react';
import { Route, Switch } from "react-router-dom";
import UserHomeNav from './UserHomeNav';
import FormList from './FormList';
import AddFormModal from './AddFormModal';
import QuestionnaireFormUILoad from './QuestionnaireFormUILoad';
import { getRecipientFormsList, getAllForms, refreshCookie, getLoggedInUserInfo } from '../../services/dataService';
import SaveAndNavigate from '../Common/SaveAndNavigate';
import * as SaveResult from '../Common/SaveResultConstants';

const SESSION_TIMEOUT_CHECK = 1000 * 10

export class UserHomePage extends Component {

    constructor(props) {
        super(props);
        this.questionnaireRef = React.createRef();
        this.state = { loggedInFlag: false, userInfo: {}, refresh: true, forms: [], recipients: [] };

    }


    async componentDidMount() {
        var userInfo = await getLoggedInUserInfo();
        this.setUserInfo(userInfo);
        this.startSessionTimer();
    }

    componentWillUnmount() {
        this.clearSessionTimer();
    }

    render() {
        return (
            <div className="main-container">
                <div className="nav-section">

                    <UserHomeNav userInfo={this.state.userInfo}
                        loggedInFlag={this.state.loggedInFlag}
                        recipients={this.state.recipients}
                        selectedRecipientId={this.state.selectedRecipientId}
                        handleRecipientChange={(selectedRecipientId, recipientType) => this.setSelectedRecipient(selectedRecipientId, recipientType)}
                    >
                    </UserHomeNav>

                    <Switch>

                        <Route
                            path="/home/"
                            exact
                            render={(props) => (
                                <AddFormModal handleRefresh={() => this.refreshRecipientsFormsList(this.state.selectedRecipientId, this.state.recipientType)}
                                    selectedRecipientId={this.state.selectedRecipientId}
                                    availableForms={this.state.availableForms}>
                                </AddFormModal>
                            )}
                        />


                        <Route
                            path="/home/form/:formId"
                            render={(props) => (<SaveAndNavigate
                                getDataHandler={this.questionnaireRef}
                                navigateAway={(saveResult) => this.navigateAway(saveResult)}
                                cancelText="Return to form list"
                            />
                            )}
                        />


                    </Switch>
                </div>
                <div className="content-section">

                    <Switch>

                        <Route
                            path="/home/"
                            exact
                            render={(props) => (
                                <FormList {...props} handleRefresh={() => this.refreshRecipientsFormsList(this.state.selectedRecipientId, this.state.recipientType)}
                                    forms={this.state.forms} />
                            )}
                        />

                        <Route
                            path="/home/form/:formId"
                            render={(props) => (

                                <QuestionnaireFormUILoad ref={this.questionnaireRef}
                                    history={props.history}
                                    handleRefresh={() => this.navigateAway(SaveResult.COMPLETED)}
                                    {...props} />
                            )}
                        />

                    </Switch>

                </div>
            </div>





        )
    }


    navigateAway = (saveResult) => {
        this.clearSessionTimer();
        this.refreshRecipientsFormsList(this.state.selectedRecipientId, this.state.recipientType);
        this.props.history.push('/home');
    }

    refreshRecipientsFormsList = async (selectedRecipientId, recipientType) => {

        const temp = await getAllForms(selectedRecipientId, recipientType);
        const availableForms = temp.map(function (item) {
            return { value: item.key, label: item.value };
        })

        const forms = await getRecipientFormsList(selectedRecipientId, recipientType);
        this.setState({ forms, availableForms });
    }


    setUserInfo = async (userInfo) => {

        var recipients = userInfo.recipients;
        this.setState({
            userInfo: userInfo,
            loggedInFlag: true,
            selectedRecipientId: (recipients && recipients.length) ? recipients[0].id : null
        });


        if (this.state.selectedRecipientId)
            this.refreshRecipientsFormsList(this.state.selectedRecipientId, this.state.recipientType);

    }


    setSelectedRecipient = (selectedRecipientId, recipientType) => {
        console.log(selectedRecipientId);

        if (selectedRecipientId) {
            this.setState({ selectedRecipientId: selectedRecipientId, recipientType: recipientType });
            this.refreshRecipientsFormsList(selectedRecipientId, recipientType);
        }


    }

    sessionTimerId = null;
    startSessionTimer() {
        this.sessionTimerId = setInterval(() => this.checkTimeout(), SESSION_TIMEOUT_CHECK);
    }

    clearSessionTimer = () => {
        if (this.sessionTimerId)
            clearInterval(this.sessionTimerId);
    }

    expireTime = null;
    checkTimeout = async () => {
        if (this.expireTime && Date.now() >= new Date(this.expireTime.getTime() - 60000 * 5)) { //Warn 5 minutes before
            this.clearSessionTimer();
            alert("About to expire");
            try {
                await refreshCookie();
                this.startSessionTimer();
            } catch (error) {
                alert("Could not refresh cookie");
            }
        }

    }

}


export default UserHomePage
